import React from 'react';
import "./HomeHeader.css"

const HomeHeader = () => {
    return (
        <div className="home-header">
            <div className="blur">
                <h1 className="m-2">Best Team In The World</h1>
            </div>
        </div>
    );
};

export default HomeHeader;